#import "../fragments/drip-sequence-stub-fragment.graphql"

query GetDripSequences(
    $limit: Int!
    $archived: Boolean!
    $cursor: String
    $sort: DripSequenceSortType!
    $search: String
    $creatorUserId: String
    $lastUpdatedTime: String
    $statuses: [CampaignStatus!]
) {
    dripSequences(
        first: $limit
        archived: $archived
        after: $cursor
        sort: $sort
        search: $search
        creatorUserId: $creatorUserId
        modifiedSinceTime: $lastUpdatedTime
        statuses: $statuses
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...DripSequenceStubFragment
            }
        }
    }
}
